import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Button, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./ForgetPasswordModal.css";
import ModalSave from "../../ModalSave";
import { postData } from "../../../../utils/api";

const ForgetPasswordModal = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    new_password: "",
    confirm_password: "",
  });

  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState({
    new: false,
    confirm: false,
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const validateOtp = () => {
    let tempErrors = {};

    if (!formData.email) {
      tempErrors.email = "Email is required";
    }

    if (!formData.otp) {
      tempErrors.otp = "OTP is required";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleVerifyOtp = async () => {
    if (!validateOtp()) return;

    try {
      const response = await postData("/verify-otp", {
        email: formData.email,
        otp: formData.otp,
      });

      if (response.success) {
        setIsOtpVerified(true);
        setShowModal({
          code: response?.code,
          message: "OTP verified successfully",
        });

        setTimeout(() => {
          setShowModal(false);
          // onHide();
        }, 2000);
      } else {

        setShowModal({
          code: response?.code,
          message: response.message,
        });

        setTimeout(() => {
          setShowModal(false);
          // onHide();
        }, 2000);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      tempErrors.email = "Enter a valid email address";
    }

    if (!formData.new_password) {
      tempErrors.new_password = "New password is required";
    } else if (formData.new_password.length < 8) {
      tempErrors.new_password = "Password must be at least 8 characters";
    } else if (
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/.test(
        formData.new_password
      )
    ) {
      tempErrors.new_password =
        "Must include uppercase, lowercase, number & special character";
    }

    if (!formData.confirm_password) {
      tempErrors.confirm_password = "Confirm password is required";
    } else if (formData.confirm_password !== formData.new_password) {
      tempErrors.confirm_password = "Passwords do not match";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await postData(`/change-password-wl`, formData);

      if (response.success) {
        setShowModal({
          code: response.code,
          message: response.message,
        });
        setTimeout(() => {
          setShowModal({ code: response.code, message: response.message });
          onHide();
        }, 2000);
      } else {

        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal(false);
          // onHide();
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }

  };

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Forget Password</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit} noValidate>
          {/* Email */}

          <Form.Group className="mb-3">
            <Form.Label>OTP</Form.Label>
            <InputGroup>
              <Form.Control
                type="number"
                name="otp"
                placeholder="Enter OTP"
                value={formData.otp}
                onChange={handleChange}
                isInvalid={!!errors.otp}
                disabled={isOtpVerified}
              />
              <Button
                variant="outline-primary"
                onClick={handleVerifyOtp}
                disabled={isOtpVerified}>
                {isOtpVerified ? "Verified" : "Verify OTP"}
              </Button>
              <Form.Control.Feedback type="invalid">
                {errors.otp}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Enter registered email"
              value={formData.email}
              onChange={handleChange}
              isInvalid={!!errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>

          {/* New Password */}
          {isOtpVerified && (
            <>
              {/* New Password */}
              <Form.Group className="mb-3">
                <Form.Label>New Password</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword.new ? "text" : "password"}
                    name="new_password"
                    value={formData.new_password}
                    onChange={handleChange}
                    isInvalid={!!errors.new_password}
                  />
                  <InputGroup.Text
                    onClick={() =>
                      setShowPassword((p) => ({ ...p, new: !p.new }))
                    }>
                    <FontAwesomeIcon
                      icon={showPassword.new ? faEyeSlash : faEye}
                    />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              {/* Confirm Password */}
              <Form.Group className="mb-3">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  isInvalid={!!errors.confirm_password}
                />
              </Form.Group>
            </>
          )}

          <div className="text-end">
            <Button variant="secondary" onClick={onHide} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Reset Password
            </Button>
          </div>
        </Form>
      </Modal.Body>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </Modal>
  );
};

export default ForgetPasswordModal;
